import { ArrowDropDown } from "@mui/icons-material";
import { Box, Button, MenuItem } from "@mui/material"
import { useRouter } from "next/router";
import { useState } from "react";
import { useSelector } from "react-redux";
import MenuPopover from "../components/extras/MenuPopover";
import CustomPopover from "./CustomPopover";
import { useIsLightColor } from '../hooks/useIsLightColor'

const CustomButton = ({ item, children = "Button", ...props }) => {

    const { push } = useRouter();
    const { reducer } = useSelector((state) => state);
    const { isSiteBuilder, pageJson } = reducer;

    if (Array.isArray(children)) {
        return <CustomPopover item={item} />
    }

    const resolvedVariant = item?.props?.variant ?? props?.variant;
    const resolvedSx = { ...(item?.props?.sx || {}), ...(props?.sx || {}) };
    const resolvedFullWidth = item?.props?.fullWidth ?? props?.fullWidth;
    const { backgroundColor } = resolvedSx || false;
    const isLightColor = backgroundColor ? useIsLightColor(backgroundColor) : false;
    const fontFamily = reducer?.pageJson?.pageStyle?.fontFamily || 'Roboto';
    const isOutlined = resolvedVariant == 'outlined';
    
    
    const textColor = isOutlined
        ? (resolvedSx?.borderColor || undefined)
        : (isLightColor ? '#000' : !backgroundColor ? undefined : '#fff');
    
    return (
        <Button
            disableElevation={true}
            {...props}
            variant={resolvedVariant}
            sx={{
                ...resolvedSx,
                width: resolvedFullWidth ? undefined : 'fit-content',
                boxShadow: 'none !important',
                textTransform:"none",
                borderColor: resolvedSx?.borderColor || undefined,
                '&:hover': {
                    backgroundColor: resolvedSx?.backgroundColor || undefined,
                    borderColor: resolvedSx?.borderColor || undefined
                },
                fontFamily:`${fontFamily}!important`,
                color: textColor
            }}
            onClick={() => {
                if (!isSiteBuilder && item?.url) {
                    if (typeof item?.url == 'string') {
                        push(item?.url)
                    }
                    else if (typeof item?.url === 'object') {
                        // push(item?.url?.path)
                        if (item.url.target) {
                            window.open(item.url.path, "_blank", "noopener,noreferrer");
                        } else {
                            push(item?.url?.path);
                        }
                    }
                }
            }}
        >{item?.label || item?.children || children || "Button"}</Button>
    )

};

export default CustomButton;